import { useEffect, useState } from "react";
import useSWR from "swr";

const fetcher = (...args: Parameters<typeof fetch>) =>
  fetch(...args).then((res) => res.json());

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false
};

// todo: change it based on query type (make, model and variant)
const useGetMmvData = () => {
  const url = `${process.env.SDUI_API_SERVICE}/mmv?vehicleType=car&journey=freshCar&mmvVersion=old`;
  const { data, error } = useSWR(url, fetcher, swrOptions);

  return {
    data,
    loading: !error && !data,
    error
  };
};

const useGetMakes = () => {
  const url =
    `${process.env.SDUI_API_SERVICE}/makes?vehicle_type=car&sort_key=is_active&sort_order=desc`;
  const { data, error } = useSWR(url, fetcher, swrOptions);

  return {
    makeData: data,
    isMakeLoading: !error && !data,
    hasMakeError: error
  };
};

const useGetModels = (makeId: any) => {
  // if (!makeId)
  //   return {
  //     modeldata: [],
  //     isModelsLoading: false,
  //     hasModelserror: false
  //   };
  const url = `${process.env.SDUI_API_SERVICE}/models?vehicle_type=car&sort_key=is_active&sort_order=asc&make_id=${makeId}&is_active=true`;
  const { data, error } = useSWR(url, fetcher, swrOptions);

  return {
    modeldata: data,
    isModelsLoading: !error && !data,
    hasModelserror: error
  };
};

const useGetVariants = (model_id: any) => {
  const url = `${process.env.SDUI_API_SERVICE}/variants?sort_key=variant_name&sort_order=desc&model_id=${model_id}&is_active=true`;
  const { data, error } = useSWR(url, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  return {
    variantdata: data,
    isVariantLoading: !error && !data,
    hasVariantserror: error
  };
};

export const useGetNcbSlabs = async (regYear, regMonth, proposal_ekey) => {
  const url = `${process.env.SDUI_API_SERVICE}/ncbSlab`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        data: {
          origin: "acko",
          product: "car",
          is_new: "false",
          registration_year: regYear,
          registration_month: regMonth,
          proposal_ekey: proposal_ekey
        }
      })
    });
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    console.log(json);
    return json;
  } catch (error: any) {
    console.error(error.message);
  }
}

export { useGetMmvData, useGetMakes, useGetModels, useGetVariants };
